import { InfoCircleOutlined, LoadingOutlined } from '@ant-design/icons'
import { Alert, Card, Space } from 'antd'
import CantileverButton from 'components/CantileverButton'
import { FC } from 'react'

interface SubmissionStepProps {
  shouldAllowSubmission: boolean
  isSubmitting: boolean
  numEntriesToUpdate: number
  selectedType: string
  onBulkEdit: () => void
}

export const SubmissionStep: FC<SubmissionStepProps> = ({
  shouldAllowSubmission,
  isSubmitting,
  numEntriesToUpdate,
  selectedType,
  onBulkEdit,
}) => {
  return (
    <Card size='default' style={{ flexShrink: 0 }}>
      <Space direction='vertical' size='middle' style={{ width: '100%' }}>
        {!shouldAllowSubmission ? (
          <Alert
            message='Validation errors prevent submission'
            description='Please fix any validation errors in the form above before submitting.'
            type='error'
            showIcon
            icon={<InfoCircleOutlined />}
          />
        ) : numEntriesToUpdate === 0 ? (
          <Alert
            message='No changes to submit'
            description='All entries already have the desired values. Make some changes to the values above to enable submission.'
            type='info'
            showIcon
            icon={<InfoCircleOutlined />}
          />
        ) : (
          <Alert
            message='Important Warnings'
            description={
              <ul style={{ margin: 0, paddingLeft: '1rem' }}>
                <li>The edit action is final and cannot be undone.</li>
                <li>
                  Any data integration jobs may overwrite the values you set.
                </li>
                <li>
                  The edit will only be run if you have sufficient permissions
                  to edit the {selectedType} type.
                </li>
              </ul>
            }
            type='warning'
            showIcon
            icon={<InfoCircleOutlined />}
          />
        )}
        <div style={{ textAlign: 'right' }}>
          <CantileverButton
            primary
            onClick={onBulkEdit}
            disabled={
              !shouldAllowSubmission || isSubmitting || numEntriesToUpdate === 0
            }
            style={{ minWidth: '250px' }}>
            {isSubmitting ? (
              <>
                <LoadingOutlined /> Updating...
              </>
            ) : (
              `Update ${numEntriesToUpdate} ${
                numEntriesToUpdate === 1 ? 'entry' : 'entries'
              }`
            )}
          </CantileverButton>
        </div>
      </Space>
    </Card>
  )
}
